<template>
  <div>
    <div>
      <div class="col">
        <div class="row">
          <div class="col-1">
            <SideBar></SideBar>
          </div>
          <div class="col mr-0 pr-0">
            <Events v-if="selectedComponent == 'events'"></Events>
            <Profile v-if="selectedComponent == 'profile'"></Profile>
            <AdminPanel v-if="selectedComponent == 'adminPanel'"></AdminPanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
import SideBar from "../components/SideBar.vue";
import Events from "../components/Events.vue";
import AdminPanel from "../components/AdminPanel.vue";
import Profile from "../components/Profile.vue";

export default {
  Name: "SecureHome",
  components: { SideBar, Events, Profile, AdminPanel },
  data() {
    return {
      collapse: false
    };
  },
  computed: {
    selectedComponent() {
      return this.$store.state.selectedComponent;
    }
  },
  methods: {
    isLoggedIn: function(message, isLoggedIn) {
      if (!isLoggedIn) {
        this.$router.push("/home/login");
      } else {
        this.userParams.getParameters();
      }
    }
  }
};
</script>